import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { Grid, Message } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { dealerState, productState } = state.importer
  const { language } = state.navigation
  const { currentUser } = state.user
  return { currentUser, language, dealerState, productState }
}

class SyncStatus extends React.PureComponent {
  render() {
    const { dealerState, productState } = this.props

    const hour = new Date().getHours()

    let statusProducts = false
    if (
      productState.deleted_count > 0 ||
      productState.new_count > 0 ||
      productState.updated_count > 0
    ) {
      if (productState.last_sync) {
        const lastSyncProducts = new Date(productState.last_sync).getHours()
        if (hour > lastSyncProducts + 2) {
          statusProducts = 'error'
        }
      } else {
        statusProducts = 'warning'
      }
    }

    let statusDealers = false
    if (
      dealerState.deleted_count > 0 ||
      dealerState.new_count > 0 ||
      dealerState.updated_count > 0
    ) {
      if (dealerState.last_sync) {
        const lastSyncDealers = new Date(dealerState.last_sync).getHours()
        if (hour > lastSyncDealers + 2) {
          statusDealers = 'error'
        }
      } else {
        statusDealers = 'warning'
      }
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={6}>
            {statusProducts && (
              <Message
                icon="warning sign"
                error={statusProducts === 'error'}
                warning={statusProducts === 'warning'}
                header={I18n.t(
                  `admin.importer.products.sync_${statusProducts}.title`
                )}
                content={I18n.t(
                  `admin.importer.products.sync_${statusProducts}.message`
                )}
                className="attached top"
              />
            )}
          </Grid.Column>
          <Grid.Column width={6}>
            {statusDealers && (
              <Message
                icon="warning sign"
                error={statusDealers === 'error'}
                warning={statusDealers === 'warning'}
                header={I18n.t(
                  `admin.importer.dealers.sync_${statusDealers}.title`
                )}
                content={I18n.t(
                  `admin.importer.dealers.sync_${statusDealers}.message`
                )}
                className="attached top"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

SyncStatus = connect(mapStateToProps)(SyncStatus)
export default SyncStatus



// WEBPACK FOOTER //
// ./src/components/admin/Helper/SyncStatus.jsx